import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo-white.png'


const _hoisted_1 = { class: "container m-auto" }
const _hoisted_2 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_3 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "img-fluid w-350px mb-6"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-6" }, "Welcome to StageHub!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_Button, {
          onClick: _ctx.signIn,
          "is-loading": _ctx.isLoading
        }, {
          default: _withCtx(() => [
            _createTextVNode("Sign In or Sign Up")
          ]),
          _: 1
        }, 8, ["onClick", "is-loading"])
      ])
    ])
  ]))
}